import * as React from 'react';
import clsx from 'clsx';
import { ICAccordion } from 'model/contentful/accordion';
import Accordion from 'components/Accordion';
import { formatAccordionItems } from './FaqSection.utils';
import { appSelectors, useAppContext } from 'contexts/app';

interface Props {
  className?: string;
}

const FaqSection: React.FC<Props> = ({ className }: Props) => {
  const { faq }: { faq?: ICAccordion } = useAppContext(state => ({
    faq: appSelectors.getFaq(state)
  }));

  const { title, itemsCollection } = faq || {};
  const items = formatAccordionItems(itemsCollection?.items);

  if (!faq) return null;

  return (
    <div className={clsx('CreditCardFAQ', className)}>
      <Accordion title={title} items={items} />
    </div>
  );
};

export default FaqSection;
